import React from "react";
// Import Link
import { Link } from "react-router-dom";
// import Img
import Img from "../../../src/assets/img/airplane.png";

const VisaText = () => {
  return (
    <>
      <section id="about_us_top" className="section_padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="about_us_left">
                {/* <h5>About us</h5> */}
                <h2>Visa</h2>
                <p>
                Navigating the complex world of visa applications requires expertise and attention to detail, and this is where House of Polani excels. Our visa facilitation services streamline the entire process, from initial documentation to final approval. We understand that each visa application is unique, and our experienced team provides personalized guidance to ensure the highest chance of success.

                </p>
                <p>
                Our comprehensive visa services cover all categories, from tourist and business visas to specialized religious travel visas. We begin by providing detailed consultation on requirements, followed by thorough documentation support. Our team meticulously reviews all applications before submission, ensuring every detail meets the exact requirements of the respective embassies and consulates.
                </p>
                <p>
                For business travelers, we offer expedited processing services and maintain strong relationships with various embassies to facilitate smooth applications. Our religious visa services are particularly specialized, handling the complex requirements for Hajj, Umrah, and Ziarat visas with expertise. We also provide additional support services such as document translation, attestation, and emergency processing when needed, making the entire visa process as smooth and stress-free as possible.
                {" "}
                </p>
                {/* <Link to="#!" className="btn btn_theme btn_sm">
                  More
                </Link> */}
              </div>
            </div>
            {/* <div className="col-lg-6">
              <div className="about_us_right">
                <img src={Img} />
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default VisaText;
